import { Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs/operators';
import { ChoiceListService } from '../choice-list/choice-list.service';

@Pipe({ name: 'asyncChoiceList' })
export class asyncChoiceListPipe implements PipeTransform {
    constructor(private choiceListService: ChoiceListService) {}

    transform(
        input: any,
        objectStore: string,
        choiceListName: string,
        gerritService: string = null
    ) {
        return this.choiceListService
            .getByID(objectStore, choiceListName, gerritService)
            .pipe(
                map(v => v.value[input]),
                map(v => (!!v ? v : ''))
            );
    }
}
